export const MODE = Object.freeze({ EXPORT: 0, AUDIT: 1, REPORT: 2 });

export const STATUS = Object.freeze({
    STARTING: 'Starting',
    PENDING: 'Pending',
    STARTED: 'Started',
    SUCCESS: 'Success',
    FAILED: 'Failure',
});

export const REPORT_API_STATUS = Object.freeze({
    QUEUED: 'QUEUED',
    STARTED: 'STARTED',
    DONE: 'DONE',
    FAILED: 'FAILED',
});

export const VALIDATION_TYPE = Object.freeze({ SDK: 'sdk', GENERAL: 'general', EVENTS: 'events' });

export const CHECK_STATUS_INTERVAL = 5000;
export const RETRY_REQUEST_COUNT = 2;
